import { V3Record } from "data/helpers/V3Record.js";

export const User = V3Record(
  "user",
  {
    id: null,
    createdAt: null,
    name: null,
    highlightedPhotoId: null,
    locality: null,
    administrativeArea: null,
    countryCode: null,
    description: null,
    accountLevel: null,
    locale: null, // this is actually just language code
    metricUnits: null,
    firstName: null,
    lastName: null,
    email: null,
  },
  {
    writeable: ["locale", "metricUnits", "firstName", "lastName", "email"],
  }
);
